import { Paper, Stack, Tooltip, Typography } from "@mui/material";
import { type FC } from "react";
import { LEAD_ACTION_TOOLTIPS } from "./lead-actions-copy";
import "./summer-campaign-leads-table.scss";

export type LeadsTab =
  | "pending"
  | "mine"
  | "processed"
  | "all"
  | "declined";

const STAT_TOOLTIPS: Record<LeadsTab | "today", string> = {
  pending: LEAD_ACTION_TOOLTIPS.statsPending,
  mine: LEAD_ACTION_TOOLTIPS.statsMine,
  processed: LEAD_ACTION_TOOLTIPS.statsProcessed,
  all: LEAD_ACTION_TOOLTIPS.statsAll,
  declined: LEAD_ACTION_TOOLTIPS.statsDeclined,
  today: LEAD_ACTION_TOOLTIPS.statsToday,
};

type Props = {
  counts: {
    pending: number;
    mine: number;
    processed: number;
    today: number;
    all: number;
    declined: number;
  };
  activeTab: LeadsTab;
  onTabSelect: (tab: LeadsTab) => void;
};

export const LeadsStatsBar: FC<Props> = ({ counts, activeTab, onTabSelect }) => {
  const cards: {
    key: LeadsTab | "today";
    label: string;
    value: number;
    navigable: boolean;
  }[] = [
    { key: "pending", label: "ממתינים לטיפול", value: counts.pending, navigable: true },
    { key: "mine", label: "בטיפול שלי", value: counts.mine, navigable: true },
    { key: "processed", label: "טופלו", value: counts.processed, navigable: true },
    { key: "all", label: "הכל", value: counts.all, navigable: true },
    { key: "declined", label: "לא לטפל", value: counts.declined, navigable: true },
    { key: "today", label: "נכנסו היום", value: counts.today, navigable: false },
  ];

  return (
    <Stack className="leads-table__stats" direction="row" flexWrap="wrap">
      {cards.map((card) => (
        <Tooltip key={card.key} title={STAT_TOOLTIPS[card.key]} arrow>
          <Paper
            variant="outlined"
            className={`leads-table__stat-card${
              card.navigable && activeTab === card.key
                ? " leads-table__stat-card--active"
                : ""
            }`}
            sx={{
              p: 1.5,
              borderRadius: "1rem",
              cursor: card.navigable ? "pointer" : "default",
            }}
            onClick={
              card.navigable ? () => onTabSelect(card.key as LeadsTab) : undefined
            }
          >
            <Typography variant="h5" fontWeight={700} color="secondary.main">
              {card.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {card.label}
            </Typography>
          </Paper>
        </Tooltip>
      ))}
    </Stack>
  );
};
